import axios from 'axios';

const BASE_URL = 'https://smsgrup.cloud/api'; 
//const BASE_URL = 'http://localhost:8000'; 

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; 
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        // Cevap başarılıysa (200, 201 vs.) olduğu gibi devam et
        return response;
    },
    (error) => {
        // Eğer hata varsa ve hata kodu 401 ise...
        if (error.response && error.response.status === 401) {
            console.warn("Oturum süresi doldu, çıkış yapılıyor...");

            // 1. Token'ı sil ki döngüye girmesin
            localStorage.removeItem('token');
            // Varsa kullanıcı bilgilerini de sil
            localStorage.removeItem('user_role'); 
            localStorage.removeItem('user_id');

            // 2. Kullanıcıyı Login sayfasına şutla
            // window.location.href kullanıyoruz çünkü React Router hook'ları (useNavigate)
            // component dışında (burada) çalışmaz. Ayrıca sayfayı tam yenilemek
            // hafızayı (state'leri) temizlemek için daha sağlıklıdır.
            window.location.href = '/login'; 
        }

        // Hatayı çağıran yere de fırlat (Catch blokları çalışsın diye)
        return Promise.reject(error);
    }
);

export default api;